import GamePrizeDisplay from './GamePrizeDisplay'
export default GamePrizeDisplay